<!-- TODO grid excel -->
<template>
	<div>
		<v-row>
			<v-spacer></v-spacer>
			<v-tooltip bottom v-if="excel">
				<template v-slot:activator="{ on, attrs }">
					<v-btn depressed @click="excelClick" icon slot="activator" v-bind="attrs" v-on="on">
						<v-icon small>fa-file-excel</v-icon>
					</v-btn>
				</template>
				<span>{{ $t('tooltips.excel') }}</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn depressed @click="toggleFilter" icon slot="activator" v-bind="attrs" v-on="on">
						<v-icon small>fa-filter</v-icon>
					</v-btn>
				</template>
				<span>{{ $t('tooltips.filter') }}</span>
			</v-tooltip>
		</v-row>
		<v-expand-transition>
			<v-row v-if="filter" wrap>
				<v-col class="pa-2">
					<v-sheet color="grey lighten-2">
						<v-row wrap>
							<v-col :key="key" v-for="(header, key) in searchableHeaders.hidden">
								<FilterField
									:filterType="'hidden'" :name="header.value" :text="header.text"
									:type="header.type"
									@changes="reloadData" v-model="request.search"></FilterField>
							</v-col>
						</v-row>
						<v-row wrap>
							<v-col>
								<v-btn class="ml-2" depressed @click="reloadData">{{ $t('buttons.filter') }}</v-btn>
								<v-btn class="ml-2" depressed @click="retoggleFilter">{{
										$t('buttons.cancelFilter')
									}}
								</v-btn>
							</v-col>
						</v-row>
					</v-sheet>
				</v-col>
			</v-row>
		</v-expand-transition>
		<v-row v-if="searchableHeaders.above.length != 0">
			<v-col :key="key" v-for="(header, key) in searchableHeaders.above">
				<FilterField
					:filterType="'above'" :name="header.value" :text="header.text" :type="header.type"
					@changes="reloadData"
					v-model="request.search"></FilterField>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-data-table
					:mobile-breakpoint="0"
					:sort-by="null"
					:headers="$props.headers"
					:items="displayItems"
					:must-sort="true"
					:no-data-text="$t('labels.noResults')"
					:no-results-text="$t('labels.noResults')"
					:server-items-length="$props.total"
					:footer-props="{
							'itemsPerPageOptions': rowsPerPage,
							'itemsPerPageText': $t('labels.rowsPerPage')
						}"
					:options.sync="request.pagination"
				>
					<template #item="props">
						<slot name="row" v-bind:item="props.item" v-if="props.item.filterRow !== true"></slot>
						<template v-if="props.item.filterRow === true">
							<td :key="key" v-for="(header, key) in $props.headers">
								<template v-if="header.searchable === 'inner'">
									<FilterField
										:filterType="'inner'" :name="header.value" :text="header.text"
										:type="header.type" @changes="reloadData"
										v-model="request.search"></FilterField>
								</template>
								<template v-if="header.searchable !== 'inner'">

								</template>
							</td>
						</template>
					</template>
					<template #pageText="props">
						{{ props.pageStart }} - {{ props.pageStop }} {{ $t('labels.of') }} {{ props.itemsLength }}
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import FilterField from "./FilterField";

export default {
	name: "DataTable",
	components: {FilterField},
	props: ['headers', 'items', 'total', 'sort', 'excel', 'additionalFilters'],
	data: function () {
		return {
			rowsPerPage: [15, 50, 100, {"text": this.$t('labels.all'), "value": -1}],
			request: {
				pagination: {},
				search: {}
			},
			filter: false
		}
	},
	computed: {
		displayItems() {
			let items = this.$props.items;
			if (this.searchableHeaders.inner.length != 0) {
				let filterRow = {
					filterRow: true
				};
				items.unshift(filterRow);
			}
			return items;
		},
		searchableHeaders() {
			let headers = {
				hidden: [],
				above: [],
				inner: []
			};
			for (let field of this.$props.headers) {
				if (field.searchable !== false) {
					headers[field.searchable].push(field);
				}
			}

			if ((typeof this.$props.additionalFilters !== 'undefined')) {
				for (let field of this.$props.additionalFilters) {
					headers[field.searchable].push(field);
				}
			}
			return headers;
		}
	},
	watch: {
		'request.pagination': {
			handler: function () {
				this.reloadData();
			},
			deep: true
		}
	},
	methods: {
		reloadData() {
			this.$emit('reload', this.request);
		},
		resetFilter() {
			for (let field of this.$props.headers) {
				if (field.type == 'string') {
					this.request.search[field.value] = '';
				}
				if (field.type == 'date_range') {
					this.request.search[field.value + '_from'] = null;
					this.request.search[field.value + '_to'] = null;
				}
				if (field.type == 'price_range') {
					this.request.search[field.value + '_from'] = null;
					this.request.search[field.value + '_from_term'] = false;
					this.request.search[field.value + '_to'] = null;
					this.request.search[field.value + '_to_term'] = false;
				}
				if (field.type == 'number_range') {
					this.request.search[field.value + '_from'] = null;
					this.request.search[field.value + '_from_term'] = false;
					this.request.search[field.value + '_to'] = null;
					this.request.search[field.value + '_to_term'] = false;
				}
				if (field.type.includes('dropdown')) {
					this.request.search[field.value] = null;
				}
				if (field.type == 'boolean') {
					this.request.search[field.value] = null;
				}
				if (field.type == 'boolean_yes') {
					this.request.search[field.value] = true;
				}
				if (field.type.includes('tags')) {
					this.request.search[field.value] = [];
				}
				if (field.type.includes('multiple')) {
					this.request.search[field.value] = [];
				}
				if (field.defaultFilter !== undefined) {
					this.request.search[field.value] = field.defaultFilter;
				}

			}
		},
		retoggleFilter() {
			this.toggleFilter();
			this.$nextTick(() => {
				this.toggleFilter();
			});
		},
		toggleFilter() {
			this.filter = !this.filter;
			if (!this.filter) {
				this.resetFilter();
				this.reloadData();
			}
		},
		changeSort(column) {
			if (this.request.pagination.sortBy === column) {
				this.request.pagination.descending = !this.request.pagination.descending
			} else {
				this.request.pagination.sortBy = column
				this.request.pagination.descending = false
			}
		},
		excelClick() {
			this.$emit('excel', this.request);
		}
	},
	mounted() {
		this.resetFilter;
	}
}
</script>

<style scoped>

</style>
